import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

export default function SuccessLevel({
  title = 'کاربر به گاراژ اضافه شد',
  text = 'حالا می‌توانید خلافی این خودرو را هم از گاراژ خود مدیریت کنید.',
}) {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.circle}`}>
        <MainIcons.CheckedIcon fill="var(--green)" width="25px" height="30px" strokeWidth="4" />
      </div>
      <h2>{title}</h2>
      <p>{text}</p>
    </div>
  );
}
